import {
  HttpContextToken,
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Logger } from '../services/logger/logger.service';
import { ToastService } from '../services/toast/toast.service';

const THREE_SECONDS_IN_MS = 3 * 1000;
export const SUPRESS_ERRORS = new HttpContextToken<boolean | string[]>(() => true);

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private lastServerErrorTime = Number.MAX_SAFE_INTEGER;

  constructor(private logger: Logger, private appToastService: ToastService) {}

  intercept<T>(request: HttpRequest<T>, next: HttpHandler) {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0 || error instanceof Error) {
          this.logger.error('client side error: ', error.error ?? error);
        } else {
          this.logger.error(`backend returned code ${error.status}, body was: `, error.error);
        }

        if (error.status >= 500 && Date.now() - this.lastServerErrorTime > THREE_SECONDS_IN_MS) {
          this.appToastService.notifyError({
            message: 'Something went wrong!',
            code: 'DXC_500'
          });
          this.lastServerErrorTime = Date.now();
        }

        if (error.status === 400) {
          const suppressErrors = request.context.get(SUPRESS_ERRORS);
          const errCode = error?.error?.error?.message?.split?.(':')[0] ?? null;

          let canShowError = true;

          if (Array.isArray(suppressErrors)) {
            canShowError = !suppressErrors.some((e) => e === errCode);
          } else {
            canShowError = suppressErrors;
          }

          if (canShowError) this.appToastService.notifyError(error.error?.error);
        }

        return throwError(() => error);
      })
    );
  }
}
